var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen flex bg-gray-200"},[(_vm.excluded)?_c('vc-navigation'):_vm._e(),_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }